import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { MoreHorizontal } from "react-feather";
import { useSelector } from "react-redux";
import Card from "../Card/Card";
import Editable from "../Editabled/Editable";
import Dropdown from "../Dropdown/Dropdown";
import CardInfo from "../Card/CardINfo/CardInfo";
import {
  updateBoardTitle,
  addCard,
  dragStart,
  dragEnd,
  dragOver,
  dropCard,
} from "../../../Redux/Reducers/CrmSlice";

import "./Board.css";
import styled from "styled-components";
import useConfirmationModal from "../../ConfirmationModal/useConfirmationModal";
import { write } from "../../../DataApi/write";
import { useSession } from "../../../authentications/SessionContext";
import { handleResponse } from "../../../utilities/handleResponse";
import { PAGINATION_DEFAULT_LIMIT } from "../../../utilities/constants";

const LoadMoreButton = styled.button`
  border-radius: 5px;
  background-color: #ff0837;
  color: #ffffff;
  border: none;
  min-width: 100px;
  margin-right: 0px;
  cursor: pointer;
  // height: 35px;
`;
function Board(props) {
  const kanban = useSelector((state) => state.crm);
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;

  const [isLoadingData, setIsLoadingData] = useState(false);
  const [offset, setOffset] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [boardTitle, setBoardTitle] = useState(props.title || "");
  const [showModal, setShowModal] = useState(false); // State to control the modal
  const dropdownRef = useRef(null);

  const { ConfirmationModal, setOpenModal, setTitle, setMetaData } =
    useConfirmationModal();
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleEditTitle = () => {
    setIsEditingTitle(true);
  };
  const handleShowDropdown = () => {
    // if (!isEditingTitle) {
    setShowDropdown(!showDropdown);
    // }
  };

  const handleTitleSubmit = (newTitle) => {
    setIsEditingTitle(false);
    props.updateBoardTitle(props.stageId, newTitle);
    // props.addCard(props.stageId, "+ Add Card");
  };

  const handleTitleChange = (newTitle) => {
    setBoardTitle(newTitle);
  };

  const handleDragStart = (event, cardId) => {
    event.dataTransfer.setData("cardId", cardId);
    event.dataTransfer.setData("stageId", props.stageId);
    props.dragStart();
  };

  const handleDragEnd = () => {
    props.dragEnd();
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    props.dragOver(props.stageId);
  };

  const handleDrop = async (e) => {
    if (kanban.draggedCard.id) {
      const change = { stage_id: props.board.stage_id };
      let response = await write({
        id: kanban.draggedCard.id,
        change,
        company_id,
        context,
      });
      response = JSON.parse(response);
      if (response.result) {
        props.dropCard({
          stageId: props.board.stage_id,
          newCard: kanban.draggedCard,
        });
      }
    }
  };
  const handleChangeOffset = (value) => {
    setIsLoadingData(false);
    setOffset((prev) => prev + value);
  };
  const handleAddLead = () => {
    props.handleCreateLead({ stageId: props.stageId });
  };

  return (
    <div className="board" onDragOver={handleDragOver} onDrop={handleDrop}>
      <ConfirmationModal
        handleYes={async () => {
          const response = await props.removeBoard(selectedBoard);
          handleResponse({
            response,
            setMetaData,
            setTitle,
            successMessage: "Board Removed Successfully",
          });
        }}
        handleNo={() => {
          setOpenModal(false);
        }}
      />
      <div className="board_header">
        <div className="board_header_title">
          {isEditingTitle ? (
            <Editable
              text={boardTitle}
              onSubmit={handleTitleSubmit}
              onChange={handleTitleChange}
              onBlur={() => setIsEditingTitle(false)}
            />
          ) : (
            <>
              {boardTitle}
              <span>{Array.isArray(props.cards) ? props.cards.length : 0}</span>
            </>
          )}
        </div>
        {showModal && (
          <CardInfo
            onClose={() => setShowModal(false)}
            card={props.card}
            stageId={props.stageId}
            updateCard={props.updateCard}
          />
        )}
        <div
          className="board_header_title_more"
          onClick={handleShowDropdown}
          ref={dropdownRef}
        >
          <MoreHorizontal />
          {showDropdown && (
            <Dropdown className="board_dropdown">
              <p onClick={handleAddLead}>Add new Lead</p>
              {/* <p onClick={() => handleEditTitle()}>Edit Board</p> */}
              <p
                onClick={() => {
                  setOpenModal(true);
                  setTitle("");
                  setMetaData({
                    dangerouslySetInnerHTML: "",
                    primaryButton: "Yes",
                    secondaryButton: "No",
                  });
                  setSelectedBoard(props.stageId);
                  setShowDropdown(false);
                }}
              >
                Delete Board
              </p>
            </Dropdown>
          )}
        </div>
      </div>

      <div className="board_cards custom-scroll">
        {props.cards.map((card) => (
          <Card
            key={card.id}
            card={card}
            stageId={props.stageId}
            removeCard={props.removeCard}
            dragStart={handleDragStart}
            dragEnd={handleDragEnd}
            updateCard={props.updateCard}
            dropCard={props.dropCard}
            handleSelectStageId={props.handleSelectStageId}
            isModalOpen={props.isModalOpen}
            handleCloseModal={props.handleCloseModal}
            handleCreateLead={props.handleCreateLead}
          >
            {card.title}
          </Card>
        ))}
        <div>
          <Editable
            text="+ Add Card"
            placeholder="Enter Card Title"
            displayClass="board_add-card add-card-text"
            editClass="board_add-card_edit"
            onSubmit={(value) => {
              if (!isEditingTitle) {
                props.addCard(props.stageId, value);
              }
            }}
            handleCreateLead={() => {
              props.handleCreateLead({
                stageId: props.stageId,
              });
            }}
            onEdit={() => setIsEditingTitle(true)}
          />
        </div>
        {props.cards?.length >= PAGINATION_DEFAULT_LIMIT && (
          <LoadMoreButton
            disabled={isLoadingData}
            onClick={() => {
              setIsLoadingData(true);
              props.LoadMoreData(props.stageId, offset, handleChangeOffset);
            }}
          >
            {isLoadingData ? "Loading..." : "load more"}
          </LoadMoreButton>
        )}
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateBoardTitle: (stageId, newTitle) =>
    dispatch(updateBoardTitle({ stageId, newTitle })),
  addCard: (stageId, title) => dispatch(addCard({ stageId, title })),
  dragStart: () => dispatch(dragStart()),
  dragEnd: () => dispatch(dragEnd()),
  dragOver: (stageId) => dispatch(dragOver({ stageId })),
  dropCard: (props) => {
    dispatch(dropCard({ ...props }));
  },
});

export default connect(null, mapDispatchToProps)(Board);
